import { defineRoutes } from "@/service/routing/schema";

const base = "/samochody";

export const carOfferRoutes = defineRoutes({
  "car_offer.index": `${base}`,
  "car_offer.vehis.index": `${base}/vehis`,
  "car_offer.vehis.show": ({
    groupId,
    subjectId,
  }: {
    groupId: string;
    subjectId: string;
  }) => `${base}/vehis/${groupId}/${subjectId}`,
  "car_offer.alior_rent": `${base}/alior-rent`,
  "car_offer.alior_rent.show": ({ uuid }: { uuid: string }) =>
    `${base}/alior-rent/${uuid}`,
  "car_offer.mercedes": `${base}/mercedes`,
} as const);
